App.BillingOperationTableRowComponent = Em.Component.extend
  tagName: 'tr'
  classNameBindings: [ 'operation.isPayment:plus:minus' ]

  session: Em.inject.service()

  invoiceCheckoutDate: (->
    date = @get('operation.invoice.checkout_date')
    return unless date

    moment(date).format('D MMMM')
  ).property('operation.invoice.checkout_date')

  invoiceIssueDate: (->
    date = @get('operation.invoice.invoice_date')
    return unless date

    moment(date).format('D MMMM')
  ).property('operation.invoice.invoice_date')

  detailedVersionUrl: (->
    return null unless @get('operation.isInvoice')
    return null unless @get('operation.invoice.has_detailed_version')

    sid    = @get('operation.invoice.secure_id')

    # Weeee
    adapter = @container.lookup('adapter:application')
    adapter.buildURL?('invoice', sid) + "/detailed.pdf"
  ).property(
    'operation.isInvoice'
    'operation.invoice.has_detailed_version',
    'operation.invoice.secure_id')

  detailedVersionActUrl: (->
    url = @get('detailedVersionUrl')
    return null unless url
    url.replace('/invoices/','/acts/')
  ).property(
    'detailedVersionUrl')
